import React from 'react';
import './CustomWrapper.scss';

interface Props {
  children: JSX.Element | React.ReactNode | React.ReactElement
  backgroundOpacity: number
  zIndex?: number
  customStyles?: React.CSSProperties
}

export const CustomWrapper: React.FC<Props> = ({ children, zIndex = 51, backgroundOpacity, customStyles = undefined }) => {
  return (
    <div
      className="customWrapper"
      style={{
        ...customStyles,
        zIndex: `${zIndex}`,
        background: `rgba(131, 131, 131, 0.${backgroundOpacity})`,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  );
};
